import type { OptionType, Transaction, TransactionSource } from "@/types/api";
import { request } from "./transport";

export interface TransactionInput {
  source?: TransactionSource;
  activity_date?: string;
  underlying?: string;
  action?: string;
  quantity?: number;
  price?: number | null;
  amount?: number | null;
  option_type?: OptionType;
  strike?: number | null;
  expiration?: string | null;
  settle_date?: string | null;
  description?: string | null;
  note_id?: string | null;
}

export const transactions = {
  listTransactions: (params?: {
    underlying?: string;
    source?: string;
    note_id?: string;
  }) => {
    const qs = new URLSearchParams();
    if (params?.underlying) qs.set("underlying", params.underlying);
    if (params?.source) qs.set("source", params.source);
    if (params?.note_id) qs.set("note_id", params.note_id);
    const q = qs.toString();
    return request<{ transactions: Transaction[] }>(
      `/transactions${q ? `?${q}` : ""}`,
    );
  },

  createTransaction: (input: TransactionInput) =>
    request<{ transaction: Transaction }>("/transactions", {
      method: "POST",
      body: JSON.stringify({ transaction: input }),
    }),

  updateTransaction: (id: string, patch: TransactionInput) =>
    request<{ transaction: Transaction }>(`/transactions/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ transaction: patch }),
    }),

  deleteTransaction: (id: string) =>
    request<{ ok: true }>(`/transactions/${id}`, { method: "DELETE" }),

  bulkImportTransactions: (rows: TransactionInput[]) =>
    request<{
      inserted: number;
      duplicates: number;
      skipped: { row: number; reason: string }[];
    }>("/transaction_imports", {
      method: "POST",
      body: JSON.stringify({ transactions: rows }),
    }),
};
